// Pages Teams opens in its authentication popup (TeamsAuthenticationPopup).
export const TEAMS_AUTH_FLOW_PATH = '/entry/auth/teams';
export const TEAMS_AUTH_FLOW_START = `${TEAMS_AUTH_FLOW_PATH}/popup/start`;
export const TEAMS_AUTH_FLOW_COMPLETE = `${TEAMS_AUTH_FLOW_PATH}/popup/complete`;
